import { gql } from '@apollo/client';

/**
 * Mutation to generate a presigned S3 URL for uploading an Excel file
 * Matches backend: generateUploadUrl(filename: String!): UploadUrlResponse!
 */
export const GENERATE_UPLOAD_URL_MUTATION = gql`
  mutation GenerateUploadUrl($filename: String!) {
    generateUploadUrl(filename: $filename) {
      uploadUrl
      fileKey
    }
  }
`;

/**
 * Mutation to parse an uploaded Excel file from S3 and extract rule data
 * Matches backend: parseUploadedExcel(fileKey: String!): ParseExcelResponse!
 */
export const PARSE_UPLOADED_EXCEL_MUTATION = gql`
  mutation ParseUploadedExcel($fileKey: String!) {
    parseUploadedExcel(fileKey: $fileKey) {
      success
      message
      data {
        ruleName
        url
        priority
        styleColorCodes
        styleCodes
        gtins
        qrs
        startDate
        startTime
        expirationDate
        expirationTime
        noExpiration
        country
        category
        division
        brandName
        athleteFullName
        boundingBox {
          north
          south
          east
          west
        }
        httpsValid
        sectionName
      }
      warnings
    }
  }
`;
